import { Button } from '@/components/ui/button/button';

interface AuthButtonProps {
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}

export function AuthButton({
  type = 'submit',
  disabled = false,
  children,
  onClick,
}: AuthButtonProps) {
  return (
    <Button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className="w-full mt-2 h-12 transition-all duration-200 transform hover:scale-[1.02]"
    >
      {children}
    </Button>
  );
}
